import { render, staticRenderFns } from "./RequestMidTermLimitChange.vue?vue&type=template&id=3955c8a4&scoped=true&"
import script from "./RequestMidTermLimitChange.vue?vue&type=script&lang=ts&"
export * from "./RequestMidTermLimitChange.vue?vue&type=script&lang=ts&"
import style0 from "./RequestMidTermLimitChange.vue?vue&type=style&index=0&id=3955c8a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3955c8a4",
  null
  
)

export default component.exports